import { createModule } from 'reacticoon/module'

import * as actions from './actions'
import * as middlewares from './middlewares'
import { loginMfaSelectors } from './selectors'
import reducer from './reducer'

const LoginMfaModule = createModule('App::LoginMfaModule', {
  actions,
  reducer,
  selectors: loginMfaSelectors,
  middlewares,
})

export default LoginMfaModule
